<template>
  <v-card class="mb-3" rounded="lg">
    <v-card-title>
      <span class="text-subtitle-2">Filtro - Contas a Receber</span>
    </v-card-title>

    <!-- <v-divider></v-divider> -->

    <v-card-text class="pb-5">
      <v-row dense>
        <v-col sm="12">
          <v-autocomplete
            v-model="contaPagarStore.filtro.fornecedor_id"
            filled
            outlined
            dense
            clearable
            placeholder=" "
            label="Fornecedor"
            :items="$store.getters['listas/fornecedores']"
          ></v-autocomplete>
        </v-col>
      <!-- </v-row>
      <v-row dense> -->
        <v-col cols="12" sm="4">
          <v-select
            filled
            outlined
            dense
            placeholder=" "
            :items="situacoes"
            v-model="contaPagarStore.filtro.situacao"
            label="Situação"
            @change="onChangeSituacao"
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <z-date-picker-menu
            v-model="contaPagarStore.filtro.data_inicial"
            filled
            outlined
            dense
            label="Data Inicial"
            placeholder=" "
            hide-details
            :disabled="dataDisabled"
          ></z-date-picker-menu>
        </v-col>
        <v-col cols="12" sm="4">
          <z-date-picker-menu
            v-model="contaPagarStore.filtro.data_final"
            filled
            outlined
            dense
            label="Data Final"
            placeholder=" "
            hide-details
            :disabled="dataDisabled"
          ></z-date-picker-menu>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelar">Cancelar Filtro</v-btn>
      <v-btn depressed color="primary" @click="filtrar" :loading="loading">Aplicar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import { useContasPagarStore } from '@/app/store/pinia/contaspagar.js';

const contaPagarStore = useContasPagarStore();

const { proxy } = getCurrentInstance();
const $store = proxy.$store;

const emit = defineEmits(['filtrar', 'cancelar']);

const situacoes = ref([
  { text: "Todas", value: "Todas" },
  { text: "Em aberto", value: "abertos" },
  { text: "Pagas", value: "pagos" },
  // { text: "Vencidas", value: "Vencidas" },
  // { text: "A Vencer", value: "AVencer" },
]);

const dataDisabled = computed(() => {
  return ["Vencidas", "AVencer"].includes(contaPagarStore.filtro.situacao);
});

const loading = ref(false);

function onChangeSituacao(situacao) {
  if (["Vencidas", "AVencer"].includes(situacao)) {
    contaPagarStore.filtro.data_inicial = null;
    contaPagarStore.filtro.data_final = null;
  }
}

function filtrar() {
  emit('filtrar');
}

function cancelar() {
  emit('cancelar');
  contaPagarStore.zerarFiltro();
}

</script>

<style lang="scss" scoped>

</style>